import React, { useReducer } from 'react'
import GitlabContext from './gitlabContext'
import GitlabReducer from './gitlabReducer'
import { apiCall } from '../../../common/api'
import { response } from '../../common'

import {
    RESPONSE_STATUS,
    CLEAR_RESPONSE,
    GET_GITLAB_STATUS,
} from './gitlabTypes'

const gitlabState = (props) => {
    const initialState = {
        responseStatus: null,
        gitlab_status: {
            records: [],
            totalRecords: 0,
            setDisp: '',
            from: '',
        },
    }

    const [state, dispatch] = useReducer(GitlabReducer, initialState)
    let resp = new response(dispatch, RESPONSE_STATUS)

    const gitlabAction = async (formData, fromVariable = 'pipelineTrigger') => {
        try {
            const [res] = await Promise.all([
                apiCall(
                    'post',
                    'pipelineTrigger',
                    formData,
                    '',
                    'third_party/gitlab'
                ),
            ])
            resp.commonResponse(res.data, fromVariable)
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const getGitlabStatus = async (
        formData,
        fromVariable = 'pipelineStatus'
    ) => {
        try {
            const [res] = await Promise.all([
                apiCall(
                    'post',
                    'pipelineStatus',
                    formData,
                    '',
                    'third_party/gitlab'
                ),
            ])

            if (res.data.status === 'success') {
                dispatch({
                    type: GET_GITLAB_STATUS,
                    payload: {
                        records: res.data.data.responseData.records.length
                            ? res.data.data.responseData.records
                            : [],
                        totalRecords: res.data.data.responseData.totalRecords,
                        setDisp: res.data.data.responseData.setDisp,
                        from: fromVariable,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, fromVariable)
            } else {
                resp.commonErrorResponse(fromVariable)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const clearResponse = () =>
        dispatch({
            type: CLEAR_RESPONSE,
        })

    return (
        <GitlabContext.Provider
            value={{
                responseStatus: state.responseStatus,
                gitlab_status: state.gitlab_status,
                gitlabAction,
                getGitlabStatus,
                clearResponse,
            }}
        >
            {props.children}
        </GitlabContext.Provider>
    )
}

export default gitlabState
